module.exports = __webpack_public_path__ + "media/images/home/required_docs-6aca5bce70b82f9e1a8d5b0ab6fca512.png";